import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Price } from 'swag-client-common/utils/price';
import classes from './discounted-price.scss';
function DiscountedPrice(props) {
  const {
    priceClass,
    price,
    planMode,
    totalBeforeDiscount,
    className
  } = props;
  return /*#__PURE__*/React.createElement("article", null, /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.initialPrice, priceClass, {
      [classes[`${planMode}-initialPrice`]]: !!planMode
    }, className),
    "data-text": "OldPrice"
  }, Price.formatPrice(totalBeforeDiscount)), /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.discountedPrice, priceClass, {
      [classes[`${planMode}-discountedPrice`]]: !!planMode
    }, className),
    "data-text": "NewPrice"
  }, price !== 0 ? Price.formatPrice(price) : 'FREE'));
}
DiscountedPrice.propTypes = {
  price: PropTypes.number.isRequired,
  priceClass: PropTypes.string,
  planMode: PropTypes.string,
  totalBeforeDiscount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string
};
export default DiscountedPrice;